export default "__VITE_ASSET__ChTskv08__"